import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

export default function CampaignManagement() {
  return (
    <>
      <Helmet>
        <title>Communication Management Services - Full-Service Solutions | RMQ Digital</title>
        <meta name="description" content="Professional communication management from strategy to execution. We handle everything so you can focus on your business." />
      </Helmet>

      <div style={{ background: 'linear-gradient(135deg, #6d28d9 0%, #8b5cf6 100%)', color: 'white', padding: '4rem 2rem', textAlign: 'center' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <h1 style={{ fontSize: '3rem', fontWeight: '800', marginBottom: '1rem' }}>Communication Management</h1>
          <p style={{ fontSize: '1.25rem', opacity: 0.95 }}>Full-service customer communication planning, execution, and optimization</p>
        </div>
      </div>

      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '4rem 2rem' }}>
        {/* Communication Management Image */}
        <div style={{ marginBottom: '4rem', borderRadius: '16px', overflow: 'hidden', boxShadow: '0 20px 60px rgba(0,0,0,0.1)' }}>
          <img 
            src="https://images.unsplash.com/photo-1552664730-d307ca884978?w=1200&h=400&fit=crop" 
            alt="Team managing communications" 
            style={{ width: '100%', height: '400px', objectFit: 'cover' }}
          />
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '2rem', marginBottom: '4rem' }}>
          <div style={{ background: 'white', padding: '2rem', borderRadius: '12px', border: '1px solid #e5e7eb' }}>
            <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>📋</div>
            <h3 style={{ fontSize: '1.5rem', fontWeight: '700', color: '#1f2937', marginBottom: '1rem' }}>
              Strategy Development
            </h3>
            <p style={{ color: '#6b7280', lineHeight: '1.6' }}>
              We create comprehensive customer communication strategies tailored to your business goals and customer needs.
            </p>
          </div>

          <div style={{ background: 'white', padding: '2rem', borderRadius: '12px', border: '1px solid #e5e7eb' }}>
            <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>✍️</div>
            <h3 style={{ fontSize: '1.5rem', fontWeight: '700', color: '#1f2937', marginBottom: '1rem' }}>
              Content Creation
            </h3>
            <p style={{ color: '#6b7280', lineHeight: '1.6' }}>
              Professional copywriting and design for all your customer notifications and service messages.
            </p>
          </div>

          <div style={{ background: 'white', padding: '2rem', borderRadius: '12px', border: '1px solid #e5e7eb' }}>
            <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>🎯</div>
            <h3 style={{ fontSize: '1.5rem', fontWeight: '700', color: '#1f2937', marginBottom: '1rem' }}>
              Audience Targeting
            </h3>
            <p style={{ color: '#6b7280', lineHeight: '1.6' }}>
              Advanced segmentation and targeting to reach the right people at the right time.
            </p>
          </div>
        </div>

        <div style={{ background: '#f9fafb', padding: '3rem', borderRadius: '12px', marginBottom: '4rem' }}>
          <h2 style={{ fontSize: '2rem', fontWeight: '700', color: '#1f2937', marginBottom: '2rem', textAlign: 'center' }}>
            What We Handle
          </h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '1.5rem' }}>
            {[
              'Communication strategy & planning',
              'Content creation & copywriting',
              'Customer segmentation',
              'Message scheduling & timing',
              'A/B testing & optimization',
              'Performance monitoring',
              'Delivery tracking & reporting',
              'Compliance management',
              'Contact list management',
              'Dedicated account manager'
            ].map((feature, idx) => (
              <div key={idx} style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <span style={{ color: '#6d28d9', fontWeight: '600' }}>✓</span>
                <span style={{ color: '#4b5563' }}>{feature}</span>
              </div>
            ))}
          </div>
        </div>

        <div style={{ background: 'linear-gradient(135deg, #6d28d9 0%, #8b5cf6 100%)', color: 'white', padding: '3rem', borderRadius: '12px', textAlign: 'center' }}>
          <h2 style={{ fontSize: '2rem', fontWeight: '700', marginBottom: '1rem' }}>
            Let Us Manage Your Communications
          </h2>
          <p style={{ fontSize: '1.1rem', marginBottom: '2rem', opacity: 0.95 }}>
            Focus on your business while we handle your customer communications
          </p>
          <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link to="/contact" style={{
              display: 'inline-block',
              background: 'white',
              color: '#6d28d9',
              padding: '1rem 2rem',
              borderRadius: '8px',
              textDecoration: 'none',
              fontWeight: '600',
              transition: 'all 0.3s ease'
            }}>
              Get Started
            </Link>
            <Link to="/pricing" style={{
              display: 'inline-block',
              background: 'rgba(255,255,255,0.2)',
              color: 'white',
              padding: '1rem 2rem',
              borderRadius: '8px',
              textDecoration: 'none',
              fontWeight: '600',
              border: '2px solid white',
              transition: 'all 0.3s ease'
            }}>
              View Pricing
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
